import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Defect, DefectSeverity } from '@jms/model';
import * as Enumerable from 'linq';
import { SortEvent, SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { NgIf, NgClass } from '@angular/common';
import { AvatarModule } from '@jms/ui/ui.avatar';
import { EmptyMessageComponent } from '@jms/ui/ui.empty.message';
import { DisplayTextPipe } from '@jms/utils/util.pipes';
import { TimezoneDatePipe } from '@workbuddy/ui/fields/luxon.calendar/pipes/timezone.date.pipe';
import { DefectEntityNamePipe } from '../../pipes/defect.entity.name.pipe';

@Component({
    selector: 'defect-list',
    templateUrl: './defect.list.component.html',
    styleUrls: ['./defect.list.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TableModule, SharedModule, NgIf, AvatarModule, NgClass, EmptyMessageComponent, DisplayTextPipe, TimezoneDatePipe, DefectEntityNamePipe]
})
export class DefectListComponent implements OnChanges {

  @Input() public defects: Defect[];
  @Input() public readonly: boolean;

  @Output() add = new EventEmitter();
  @Output() edit = new EventEmitter<string>();
  @Output() delete = new EventEmitter<string>();

  public isScroll = true;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes?.defects) {
      this.isScroll = this?.defects?.length ? true : false;
    }

  }

  public onAdd() {
    this.add.emit();
  }

  public onEdit(defectId: string) {
    this.edit.emit(defectId);
  }

  public onDelete(defectId: string) {
    this.delete.emit(defectId);
  }

  public onCustomSort(event: SortEvent) {

    const { field, mode, order } = event;

    if (field === 'severity') {

      this.defects = Enumerable.from(this.defects)
        .orderBy(x => {

          if (order === 1) {

            if (x.severity === DefectSeverity.Low)
              return 1;

            if (x.severity === DefectSeverity.Medium) {
              return 2;
            }

            if (x.severity === DefectSeverity.High) {
              return 3;
            }

            if (x.severity === DefectSeverity.Critical) {
              return 4;
            }

          } else {
            if (x.severity === DefectSeverity.Low)
              return 4;

            if (x.severity === DefectSeverity.Medium) {
              return 3;
            }

            if (x.severity === DefectSeverity.High) {
              return 2;
            }

            if (x.severity === DefectSeverity.Critical) {
              return 1;
            }
          }

        }).toArray();

    } else {
      event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = null;

        if (value1 == null && value2 != null)
          result = -1;
        else if (value1 != null && value2 == null)
          result = 1;
        else if (value1 == null && value2 == null)
          result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string')
          result = value1.localeCompare(value2);
        else
          result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

        return (event.order * result);
      });
    }


  }

}
